export const LicenseStylesColums = {
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    justifyContent: "center",
    width: "100%",
  },
};
